<template functional>
    <svg
        width="18px"
        height="18px"
        viewBox="0 0 18 18"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <title>Proposed</title>
        <g id="Icons-/-Circle-empty" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <circle id="Proposed" stroke="#8BA4B7" cx="9" cy="9" r="8.5" />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'CircleEmpty',
};
</script>
